export default __webpack_public_path__ + "static/media/hiw-3.dfe80da2.svg";